import LoadingBox from 'components/Common/Loading/LoadingBox'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Divider from 'LuxKit/Divider'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import { memo } from 'react'

function FareFamilyFareOptionSkeleton() {
  // This is a skeleton/loading component — the only "string" is {' '} (a space between two loading boxes)
  // This isn't translatable text
  // and wrapping this inside formattedmessage seems like unnecessary overhead
  return <Pane border="neutral-five" borderRadius="S" padding="24 16" data-testid="fare-family-option-skeleton">
    <VerticalSpacer gap={16}>
      <VerticalSpacer gap={8}>
        <div>
          <TextLoadingBox typography="heading6" width={146} />
          <TextLoadingBox typography="caption-medium" width={102} />
        </div>
        <div>
          <div>
            <TextLoadingBox typography="heading6" inline width={67} />{' '}
            <TextLoadingBox typography="body-small" inline width={32} />
          </div>
          <TextLoadingBox typography="body-medium" width={80} />
        </div>
      </VerticalSpacer>
      <LoadingBox style={{ height: 40, width: '100%' }} />
      <Divider kind="primary" />
      <VerticalSpacer gap={12}>
        <TextLoadingBox typography="body-small" width={67} />
        <VerticalSpacer gap={8}>
          <TextLoadingBox typography="caption-medium" width="100%" />
          <TextLoadingBox typography="caption-medium" width="100%" />
          <TextLoadingBox typography="caption-medium" width="100%" />
          <TextLoadingBox typography="caption-medium" width="100%" />
          <TextLoadingBox typography="caption-medium" width="100%" />
          <TextLoadingBox typography="caption-medium" width="100%" />
        </VerticalSpacer>
      </VerticalSpacer>
    </VerticalSpacer>
  </Pane>
}

export default memo(FareFamilyFareOptionSkeleton)
